import type { Step } from '@/components/GuideMe'
import type { OutcomeStatus } from '@/types/Outcome'
import { isFinalOutcome } from '@/utils/outcome'

export const getGuideMeCreditData = (creditOutcomeStatus?: OutcomeStatus): Step[] => {
  if (creditOutcomeStatus === undefined) {
    return []
  }

  if (isFinalOutcome(creditOutcomeStatus)) {
    return [
      {
        title: 'Nothing left to do for credit 🎉',
        description: 'This section now has an outcome and is closed.',
        supportingDocuments: null,
        callToAction: null,
      },
    ]
  }

  return [
    {
      title: 'Credit criteria',
      description:
        'If you have any questions on progressing a Credit Section, follow this link to read through all our Credit requirements and criteria.',
      supportingDocuments: null,
      callToAction: {
        url: 'https://www.notion.so/referencing/Credit-8e66012ad5444462a76d630ddb433bbb',
        text: 'View Criteria',
      },
    },
  ]
}
